import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=71df949d"
import script from "./tabbar.vue?vue&type=script&lang=ts"
export * from "./tabbar.vue?vue&type=script&lang=ts"
import style0 from "./tabbar.vue?vue&type=style&index=0&id=71df949d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports